module.exports = __webpack_public_path__ + "app/modals/iframe.view.html";